<template>
  <div style="height: 100%"  @touchstart="toRoute"  @click="toRoute">
    <label style="padding: 20px 0 10px 30px;">
      <b-icon icon="circle" style="margin-right: 5px;"></b-icon>
      WUE变化趋势 </label>
    <el-carousel :arrow="tempHumidityData.length>1?'always':'never'" :interval="50000" indicator-position="none"
                 style="height: 80%;z-index: 0">

      <line-chart-pue :data="lineData" :extend-data="lineExtentData" name="wue变化趋势"
                      ref="lineChart"
                      style="height: 90%"
                      v-if="lineData.time && lineData.time.length > 0"></line-chart-pue>
      <no-data style="padding-top: 12%;" v-else></no-data>
    </el-carousel>
  </div>
</template>

<script>
import LineChartPue from "@/components/echarts/LineChartPue";
import NoData from "@/components/NoData";
import {getPueTrend} from "@/network/ems-record.js"
import {getSystematicByParent} from "@/network/systematic";
import platenLayoutEdit from '@/mixins/platenLayoutEdit'

export default {
  name: "TrendWue",
  mixins: [platenLayoutEdit],
  components: { NoData,LineChartPue},
  data() {
    return {
      date: [],//日期选择
      tempHumidityData: [],
      extendData: null,
      lineData: {},
      lineExtentData:{ "xAxis": [ { "axisLabel": { "rotate": 45 } } ] },
      route: ''
    };
  },
  created() {
    this.$store.dispatch('addIntervalObj', {'getRoomEnvironmentDevice:500000': this.getData})
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getRoomEnvironmentDevice')
  },
  mounted() {
    this.getLinkage();
    // 默认是选到1周的
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
    this.date[0] = start;
    this.date[1] = end;
    this.dateChange(this.date);
  },
  methods: {
    //获取子系统地址
    getLinkage() {
      //let codes = ["linkage"];
      getSystematicByParent().then(res => {
        let system = res.data.filter(system => system.appName === "能耗系统")[0];
        if(system){
          this.route=system.website+'#/pueAnalyse';
        }
      })
    },
    toRoute(){
      if (this.isPlatenLayoutEditing) return
      if(this.route){
        // window.open(this.route, '_blank')
        this.$router.push({path: this.route})
      }
    },
    dateChange(val) {
      this.getLineData(val[0], val[1]);
    },
    getLineData(startTime, endTime) {
      getPueTrend(startTime, endTime, 'water').then(res => {
        if (res.code === 0) {
          this.lineData = res.data
        }
      })
    },
  }
}
</script>

<style scoped>

label {
  font-weight: bold;
  color: #01EFFD;
}

.el-carousel >>> .el-carousel__arrow {
  top: 5%;
}
</style>
